<span class="pt-language-change__description">
  {{ 'prefferedLanguage.description' | translate }}
</span>

<pu-select
  [formControl]="$any(languageControl)"
  [items]="availableLanguages()"
/>

<div class="pt-language-change__actions">
  <button
    type="button"
    puButton
    size="m"
    uiType="primary"
    translate="prefferedLanguage.confirm"
    (click)="changeLanguage()"
  >
  </button>
</div>
